var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{ref:"sitesways",attrs:{"table-ref":"site_ways","title":"Sites Ways","icon":"fa fa-sort-numeric-up","hide-org-badge":"","url":"/view/sites/ways","trackBy":"ways","sortField":"ways","fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }